import React, { useEffect, useState } from 'react';
import Table, { CurrencyCell, MultiSelectFilter, includesOr } from './controls/Table';

function GroceryHistory() {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);


  const getData = async () => {
    try {
      const response = await fetch('api/groceries/getgroceryhistory');
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const orderColumns = React.useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        Footer: '',
      },
      {
        Header: 'Store',
        accessor: 'store.storeName',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Time',
        accessor: 'transactionTime',
        Footer: '',
      },
      {
        Header: 'Total',
        accessor: 'total',
        Cell: CurrencyCell,
        Footer: '',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.total + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'Items',
        accessor: 'items.length',
        Footer: '',
      },
      {
        Header: 'Savings',
        accessor: 'savings',
        Cell: CurrencyCell,
        Footer: '',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.savings + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'Tax',
        accessor: 'tax',
        Cell: CurrencyCell,
        Footer: '',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.tax + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'Type',
        accessor: 'fullfillmentType',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
    ],
    []
  );

  const itemColumns = React.useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        Footer: '',
      },
      {
        Header: 'Quantity',
        accessor: 'quantity',
        Footer: '',
      },
      {
        Header: 'UnitPrice',
        accessor: 'unitPrice',
        Cell: CurrencyCell,
        Footer: '',
      },
      {
        Header: 'TotalSavings',
        accessor: 'totalSavings',
        Cell: CurrencyCell,
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.totalSavings + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'UnitPricePaid',
        accessor: 'unitPricePaid',
        Cell: CurrencyCell,
        Footer: '',
      },
      {
        Header: 'TotalPaid',
        accessor: 'totalPaid',
        Cell: CurrencyCell,
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.totalPaid + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'Department',
        accessor: 'item.department',
        Footer: '',
      },
      {
        Header: 'Aisle',
        accessor: 'item.aisle',
        Footer: '',
      },
      {
        Header: 'UPC',
        accessor: 'item.item.upc',
        Footer: '',
      },
      {
        Header: 'Brand',
        accessor: 'item.item.brand',
        Footer: '',
      },
      {
        Header: 'Description',
        accessor: 'item.item.description',
        Footer: '',
      },
      {
        Header: 'Size',
        accessor: 'item.item.size',
        Footer: '',
      },
      {
        Header: 'UnitOfMeasure',
        accessor: 'item.item.unitOfMeasure',
        Footer: '',
      },

      /*
        public string Brand { get; set; } = string.Empty;
        public string Description { get; set; } = string.Empty;
        public string Size { get; set; } = string.Empty;
        public string UnitOfMeasure { get; set; } = string.Empty; */
      /*{
        Header: 'Date',
        accessor: 'date',
        Footer: '',
      },
      {
        Header: 'Type',
        accessor: 'type',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Quantity',
        accessor: 'quantity',
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.quantity + sum, 0);
          return <>{total}</>;
        },
      },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: ({ row }) => {
          const price = Math.abs(row.original.costBasis / row.original.quantity);
          return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)}</>;
        },
        sortType: (rowA, rowB) => {
          const a = Math.abs(rowA.original.costBasis / rowA.original.quantity);
          const b = Math.abs(rowB.original.costBasis / rowB.original.quantity);
          return a === b ? 0 : a > b ? 1 : -1;
        },
        Footer: '',
      },
      {
        Header: 'CostBasis',
        accessor: 'costBasis',
        Cell: CurrencyCell,
        sortType: (rowA, rowB) => {
          const a = rowA.original.costBasis;
          const b = rowB.original.costBasis;
          return a === b ? 0 : a > b ? 1 : -1;
        },
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.costBasis + sum, 0);
          return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</>;
        },
      },
      {
        Header: 'CurrentTotal',
        accessor: 'currentTotal',
        Cell: ({ row }) => {
          const currentTotal = prices[row.original.symbol]?.price * row.original.quantity;
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(currentTotal)}</b></>;
        },
        sortType: (rowA, rowB) => {
          const a = prices[rowA.original.symbol]?.price * rowA.original.quantity;
          const b = prices[rowB.original.symbol]?.price * rowB.original.quantity;
          return a === b ? 0 : a > b ? 1 : -1;
        },
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.quantity * prices[row.original.symbol]?.price + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'Gains',
        accessor: 'gains',
        Cell: ({ row }) => {
          const gains = prices[row.original.symbol]?.price * row.original.quantity + row.original.costBasis;
          return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(gains)}</>;
        },
        sortType: (rowA, rowB) => {
          const a = prices[rowA.original.symbol]?.price * rowA.original.quantity + rowA.original.costBasis;
          const b = prices[rowB.original.symbol]?.price * rowB.original.quantity + rowB.original.costBasis;
          return a === b ? 0 : a > b ? 1 : -1;
        },
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.costBasis + row.values.quantity * prices[row.original.symbol]?.price + sum, 0);
          return <>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</>;
        },
      },
      {
        Header: 'Tax',
        accessor: 'tax',
        Cell: ({ row }) => {
          return row.original.account.taxFree ? "-" : isLongTerm(row.original.date) ? "Long" : "Short";
        },
      },*/
    ],
    []
  );

  const getNestedData = (row) => {
    return row.original.items || [];
  };

  return (
    <div>
      <div>
        <h4>Grocery History ({data.length})</h4>
        <Table
          columns={orderColumns}
          data={data}
          nestedColumns={itemColumns}
          getNestedData={getNestedData}>
        </Table>
      </div>
    </div>
  );
}

export default GroceryHistory;